import { Lock, LineChart } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { money } from "@/lib/format";

const FIELDS = [
  ["annual_revenue", "المبيعات / الإيرادات السنوية (ر.س)"], ["net_profit", "صافي الربح السنوي (ر.س)"],
  ["total_assets", "إجمالي الأصول (ر.س)"], ["total_liabilities", "إجمالي الالتزامات (ر.س)"],
];

export const EMPTY_FIN = { financial_year: "", annual_revenue: "", net_profit: "", total_assets: "", total_liabilities: "", notes: "" };

const n = (v) => (v === "" || v == null ? null : Number(v));
export const cleanFin = (f) => ({ ...f, ...Object.fromEntries(FIELDS.map(([k]) => [k, n(f[k])])) });

export const FinancialsForm = ({ v, set }) => (
  <div className="border border-slate-200 rounded-xl p-5 space-y-4" data-testid="financials-form">
    <div>
      <h3 className="font-bold flex items-center gap-2"><LineChart size={18} className="text-slate-600" />البيانات المالية</h3>
      <p className="text-xs text-slate-500 mt-1">لا تظهر للزوار إلا بعد موافقة الإدارة على طلب التواصل.</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-3">
      <div><label className="text-xs font-semibold">السنة المالية</label><Input data-testid="fin-financial_year" value={v.financial_year} onChange={(e) => set({ ...v, financial_year: e.target.value })} placeholder="2025" className="h-10 rounded-lg mt-1" /></div>
      {FIELDS.map(([k, l]) => <div key={k}><label className="text-xs font-semibold">{l}</label><Input data-testid={`fin-${k}`} type="number" value={v[k]} onChange={(e) => set({ ...v, [k]: e.target.value })} className="h-10 rounded-lg mt-1" dir="ltr" /></div>)}
      <div className="sm:col-span-2"><label className="text-xs font-semibold">ملاحظات مالية</label><Textarea data-testid="fin-notes" value={v.notes} onChange={(e) => set({ ...v, notes: e.target.value })} className="rounded-lg mt-1" /></div>
    </div>
  </div>
);

export const FinancialsView = ({ f, locked }) => {
  if (locked) return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 flex items-center gap-3" data-testid="financials-locked">
      <Lock size={18} className="text-slate-500 shrink-0" />
      <div><div className="font-bold text-slate-900">البيانات المالية متاحة</div><p className="text-sm text-slate-500">تظهر المبيعات والأرباح والأصول والالتزامات بعد موافقة الإدارة على طلب التواصل.</p></div>
    </div>
  );
  if (!f) return null;
  const equity = f.total_assets != null && f.total_liabilities != null ? f.total_assets - f.total_liabilities : null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6" data-testid="financials-view">
      <h2 className="font-bold mb-4 flex items-center gap-2"><LineChart size={18} className="text-slate-600" />البيانات المالية {f.financial_year && <span className="text-xs font-semibold text-slate-500">({f.financial_year})</span>}</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-slate-200 border border-slate-200 rounded-lg overflow-hidden">
        {[...FIELDS, ["equity", "صافي حقوق الملكية"]].map(([k, l]) => (
          <div key={k} className="bg-white p-4"><div className="text-xs text-slate-500">{l.replace(" (ر.س)", "")}</div>
            <div className="text-lg font-bold text-slate-900 tabular-nums mt-1" data-testid={`fin-view-${k}`}>{money(k === "equity" ? equity : f[k])}</div></div>
        ))}
      </div>
      {f.notes && <p className="text-sm text-slate-600 mt-4 whitespace-pre-line">{f.notes}</p>}
    </div>
  );
};
